import { render, staticRenderFns } from "./CreateBiosignalsBlock.vue?vue&type=template&id=a55203f4&scoped=true"
import script from "./CreateBiosignalsBlock.vue?vue&type=script&lang=js"
export * from "./CreateBiosignalsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55203f4",
  null
  
)

export default component.exports